// https://docs.datadoghq.com/real_user_monitoring/browser/
import { datadogRum } from '@datadog/browser-rum'
import type { RumEvent } from '@datadog/browser-rum'

// Google Cloud Storage signed URLs carry the credential and the signature in the query string, so a
// captured resource event is enough to refetch the document inside its signing window. ActiveStorage
// signs downloads with v2 and SfFile signs uploads with v4, so both parameter sets are here.
const SIGNED_URL_PARAM_PATTERN =
  /([?&])(Signature|GoogleAccessId|Expires|X-Goog-Signature|X-Goog-Credential|X-Goog-Date|X-Goog-Expires|X-Goog-SignedHeaders|X-Goog-Algorithm)=[^&#]*/g

export function redactSignedUrlParams(url: string): string {
  return url.replace(SIGNED_URL_PARAM_PATTERN, '$1$2=REDACTED')
}

// The RUM types mark these fields readonly, but TypeScript does not enforce readonly across an
// assignment to a parameter, so this reaches them without a cast.
function redactUrls(target?: { url?: string; referrer?: string }): void {
  if (!target) return

  if (target.url) target.url = redactSignedUrlParams(target.url)
  if (target.referrer) target.referrer = redactSignedUrlParams(target.referrer)
}

export function beforeSend(event: RumEvent): boolean {
  redactUrls(event.view)

  if (event.type === 'resource') redactUrls(event.resource)
  if (event.type === 'error') redactUrls(event.error.resource)

  return true
}

window.DD_RUM = datadogRum
window.DD_RUM_BEFORE_SEND = beforeSend
